import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';

import Slider from 'react-slick';
import ReactPlayer from 'react-player'

import { useQuery } from '@apollo/react-hooks';
import { GET_PROJECT } from './queries';
import { IProject } from '../../helper/Types';
import { getCategoryTypeTitle, getCategoryProgramTitle } from '../../helper/constants';

import { useQueryParams, StringParam, BooleanParam } from 'use-query-params';
import * as queryString from 'query-string';

import { VALoading, VALazyImage } from '../../components';

import useDocTitle from '../../hooks/useDocTitle';


function ProjectDetailContainer() {
    const history = useHistory();
    const params:any = useParams();
    const [current, setCurrent] = useState(1);
    const [query, setQuery] = useQueryParams({
        year: StringParam,
        type: StringParam,
        program: StringParam,
    });
    
    const loadData = useQuery<IProject>(GET_PROJECT, {
        variables: {
            uid: params.uid,
            year: query.year,
            type: query.type,
            program: query.program
        }
    });

    let description = (null);
    let media = (null);
    let settingsMedia = {
        dot: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        afterChange: (current:number) => {
            setCurrent(current+1)
        },
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    dot: false,
                    arrow: false,
                    rows: 1,
                }
            }
        ]
    };


    const [title, setTitle] = useDocTitle('');
    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const _data:any = loadData;
            const { post } = _data.data?.project;

            setTitle(post.title);
        }
    }, [loadData]);


    if( !loadData.loading && !loadData.error ) {
        const _data:any = loadData;
        const { post, nextUid } = _data.data?.project;

        description = (
            <header className="post-detail">
                <h1 className="title">{post.title}</h1>
                <dl className="description">
                    <div className="description-item">
                        <dt>Year.</dt>
                        <dd>{post.year}</dd>
                    </div>
                    <div className="description-item">
                        <dt>Type.</dt>
                        <dd>{getCategoryTypeTitle(post.project.type)}</dd>
                    </div>
                    <div className="description-item">
                        <dt>Program.</dt>
                        <dd>{getCategoryProgramTitle(post.project.type, post.project.program)}</dd>
                    </div>
                    <div className="description-item">
                        <dt>Location.</dt>
                        <dd>{post.project.location}</dd>
                    </div>
                </dl>
                { post.project.external && <a href={post.project.external} target="__blank" className="btn-external">Link</a>}
                
                <span className="current">{current}/{post.media.length}</span>
            </header>
        );
    
        settingsMedia = {
            ...settingsMedia,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        dot: false,
                        arrow: false,
                        rows: post.media.length,
                    }
                }
            ]
        }

        media = post.media.map((_item:any, _index:number) => {
            if( _item.type === 'photo' ) {
                return(
                    <div key={_index} className="photo">
                        <div className="inner" style={{ backgroundImage: `url('${_item.url}')` }}>
                            <img src={_item.url} alt="" />    
                        </div>
                    </div>
                    // <VALazyImage key={_index} src={_item.url} alt="" />
                );
            }
            if( _item.type === 'video' ) {
                return(
                    <div key={_index} className="video">
                        <div className="inner">
                            <ReactPlayer url={_item.url} height='100%' width='100%' controls className="vimeo-player" />
                        </div>
                    </div>
                );
            }
        });
    }

    const _nextUid:String | undefined = loadData.data?.project.nextUid;
    const stringified = queryString.stringify(query);
    const nextUrl:any = `/project/${_nextUid}?${stringified}`;

    return(
        <article className="layout-contents-container page-details">
            <button type="button" className="btn-back" onClick={history.goBack}>Back</button>

            { loadData.loading && <VALoading data-size="xlarge" /> }
            { loadData.error && <div>에러가 발생했습니다.</div> }

            {description}

            <Slider className="list-media" {...settingsMedia}>
                {media}
            </Slider>

            <div className="project-navigation">
                <button type="button" className="btn-nav" onClick={history.goBack}>Back</button>
                <Link to={nextUrl} className="btn-nav" data-disabled={!loadData.data?.project.nextUid}>Next project</Link>
            </div>
        </article>
    );
}

export default ProjectDetailContainer;
